import { render, staticRenderFns } from "./toback.vue?vue&type=template&id=0416de95&scoped=true"
import script from "./toback.vue?vue&type=script&lang=js"
export * from "./toback.vue?vue&type=script&lang=js"
import style0 from "./toback.vue?vue&type=style&index=0&id=0416de95&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0416de95",
  null
  
)

export default component.exports